import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalFormContainerComponent } from '../../../../../../components/ui/modal-form-container/modal-form-container.component';
import { SearchInputComponent } from '../../../../../../components/inputs/search-input/search-input.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { formatCount } from '../../../../../../../utils/sms';

@Component({
  selector: 'message-phone-numbers-modal',
  standalone: true,
  imports: [ModalFormContainerComponent, SearchInputComponent, MatTooltipModule],
  templateUrl: './message-phone-numbers-modal.component.html',
  styleUrls: ['./message-phone-numbers-modal.component.css', '../selected-list.css'],
})
export class MessagePhoneNumbersModalComponent {
  constructor() {}

  @Input() open: boolean = false;
  @Input() phoneNumbers: string[] = [];
  @Output() removePhoneNumber = new EventEmitter<string>();
  @Output() close = new EventEmitter();

  formatCount = formatCount;
  term = '';

  get shown(): string[] {
    const term = this.term.replace(/\s+/g, '');
    if (!term) return this.phoneNumbers;
    return this.phoneNumbers.filter((number) => number.replace(/\s+/g, '').includes(term));
  }

  closeModal() {
    this.term = '';
    this.close.emit();
  }
}
